import * as enUS from '../../translations/en-US.json';
import * as deDE from '../../translations/de-DE.json';
import * as plPL from '../../translations/pl-PL.json';
import * as skSK from '../../translations/sk-SK.json';

/**
 * The bundled translation entries for a language. Single source of the
 * language -> bundled-JSON mapping (CLAUDE.md › i18n: translations are
 * bundled, not fetched), used for `ROUTES.*` lookups in both directions.
 */
export function routeTranslations(lang: string): Record<string, string> {
    switch (lang) {
        case 'pl':
            return <Record<string, string>>{ ...plPL };
        case 'en':
            return <Record<string, string>>{ ...enUS };
        case 'de':
            return <Record<string, string>>{ ...deDE };
        case 'sk':
            return <Record<string, string>>{ ...skSK };
        default:
            return {};
    }
}
